import { PlusOutlined } from '@ant-design/icons';
import { message, Upload, UploadFile, UploadProps } from 'antd';
import { useEffect, useState } from 'react';

type AvatarUploadProps = UploadProps & {
  file?: Blob;
  setFile: (file?: Blob) => void;
  existingPicture?: UploadFile;
  maxSize?: number;
};

const uploadButton = (
  <button style={{ border: 0, background: 'none' }} type="button">
    <PlusOutlined />
    <div style={{ marginTop: 8 }}>Upload</div>
  </button>
);

/**
 * @param {UploadFile} existingPicture - The existing picture if any, to make sure
 *  if user cancel the upload, the existing picture will be shown.
 */

const AvatarUpload = ({
  file: profilePicture,
  setFile: setProfilePicture,
  existingPicture,
  maxSize = 1048576,
  ...props
}: AvatarUploadProps) => {
  const [isExistingDeleted, setIsExistingDeleted] = useState(false);
  const [previewFile, setPreviewFile] = useState<UploadFile | undefined>(
    existingPicture,
  );

  useEffect(() => {
    if (!profilePicture && existingPicture) {
      setPreviewFile(previewFile);
    }
  }, [profilePicture]);

  useEffect(() => {
    if (!isExistingDeleted && existingPicture) setPreviewFile(existingPicture);
  }, [existingPicture]);

  return (
    <Upload
      accept=".png,.jpg,.jpeg"
      maxCount={1}
      fileList={previewFile ? [previewFile] : []}
      listType="picture-circle"
      showUploadList={{
        showPreviewIcon: false,
      }}
      onRemove={() => {
        setProfilePicture(undefined);
        setPreviewFile(undefined);
        setIsExistingDeleted(true);
      }}
      beforeUpload={(file) => {
        if (file.size > maxSize) {
          message.error(
            `Maximum file size is ${Math.floor(maxSize / 1048576)} MB`,
          );
          return false;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          setPreviewFile({
            uid: file.uid,
            name: file.name,
            status: 'done',
            url: reader.result as string,
            originFileObj: file,
          });
        };
        setProfilePicture(file);
        return false;
      }}
      {...props}
    >
      {!profilePicture &&
        (!existingPicture || isExistingDeleted) &&
        uploadButton}
    </Upload>
  );
};

export default AvatarUpload;
